import { checkClientPeppolStatus } from 'api/v2/clients';
import useQuery from 'hooks/react-query/useQuery';
import { UseQueryOptions } from '@tanstack/react-query';
import { IntegrationsCacheKeys } from 'types/cacheKeys.types';
import { Nullable } from 'types/global.types';

const useCheckClientPeppolStatus = (
  id: Nullable<string>,
  documentTypes: Nullable<'invoice' | 'creditnote'>,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>,
) => {
  const enabled = !!id && !!documentTypes && options?.enabled !== false;
  return useQuery(
    [
      IntegrationsCacheKeys.ClientPeppolIntegrationStatus,
      id,
      documentTypes,
      enabled,
    ],
    () => checkClientPeppolStatus(id!, documentTypes!),
    {
      ...(options as any),
      enabled,
    },
  );
};

export default useCheckClientPeppolStatus;
